/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useSWR from 'swr';

import { Verified } from '@components/avatar';
import { ThumbnailBoard } from '@components/thumbnail-board';
import { getSmallestImageBoardPreview } from '@utils/token';
import { useMedia } from '@utils/use-media';
import { getScreenName } from '@utils/user';
import { Box, Button, Text } from '@versumstudios/ui';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

interface ICuratedOn {
  id: string;
}

export const CuratedOn: FC<ICuratedOn> = ({ id }) => {
  const router = useRouter();
  const total = useMedia(['(min-width: 1440px)', '(min-width: 640px)'], [6, 4], 2);

  const { data } = useSWR(() => `/api/public/boards/token/${id}`, fetcher, {
    revalidateOnFocus: false,
  });

  if (data?.token_lists.length > 0) {
    return (
      <>
        <Text as="h6">Curated on</Text>

        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))`,
            gap: '0 0',
            padding: '0 0 $space$2 0',
            border: '1px solid transparent', // transparent addresses iOS bug where children dont display side by side

            '@bp1': {
              border: 'none',
              gap: '$2 $2',
            },
          }}
        >
          {data?.token_lists.map((board: any, index: number) => {
            const screenName = getScreenName(
              board.user.verified_on_chain,
              board.user.screen_name,
              board.user.id,
              board.user.name
            );

            if (index < total) {
              const images = board.tokens
                .map(({ token }: any) => getSmallestImageBoardPreview(token))
                .map((e: any) => e.src);

              return (
                <Box key={`curated-on-${board.id}`} css={{ flexDirection: 'column' }}>
                  <Link href={`/board/${board.id}`} locale={router.locale} prefetch={false} passHref>
                    <a>
                      <ThumbnailBoard key={board.id} cover={board.cover_uri} images={images} />
                    </a>
                  </Link>
                  <Box css={{ flexDirection: 'column', padding: '$space$4' }}>
                    {board.title && (
                      <Text unset css={{ textAlign: 'left' }} ellipsis>
                        <strong>{board.title}</strong>
                      </Text>
                    )}

                    <Link href={`/user/${board.user.id}/created`} locale={router.locale} prefetch={false} passHref>
                      <Button as="a" variant="basic" css={{ fontSize: 14, lineHeight: 1, display: 'flex' }}>
                        {screenName}
                        {board.user.verified_on_chain && <Verified size={10} secondary />}
                      </Button>
                    </Link>
                  </Box>
                </Box>
              );
            }
            return null;
          })}
        </Box>
      </>
    );
  }

  return null;
};
